import { render, staticRenderFns } from "./SiteHeader.vue?vue&type=template&id=ca020ad0&scoped=true&"
import script from "./SiteHeader.vue?vue&type=script&lang=js&"
export * from "./SiteHeader.vue?vue&type=script&lang=js&"
import style0 from "./SiteHeader.vue?vue&type=style&index=0&id=ca020ad0&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca020ad0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconBackArrow: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconBackArrow.vue').default,AppButton: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppButton.vue').default,SvgIconHamburger: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconHamburger.vue').default,CmsRichText: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsRichText.vue').default,AppImg: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppImg.vue').default,SvgIconSnoozeLogo: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconSnoozeLogo.vue').default,SearchBar: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/search/SearchBar.vue').default,HeaderRightIcons: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/layout/HeaderRightIcons.vue').default,FirstLevelMenu: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/layout/FirstLevelMenu.vue').default})
